<template>
  <div>
    <loading-spinner v-if="loading"></loading-spinner>
    <template v-else>
      <header-card
        icon="thumb_up"
        title="Employee Recognition"
        sub-title="Let's give someone a little praise today"
      >
        <template v-slot:right>
          <div class="secondary--text font-weight-medium subtitle-1">
            Members Recognized
          </div>
          <div>
            {{ member_count }}
          </div>
        </template>
        <template v-slot:extension>
          <v-divider></v-divider>
          <v-row dense>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
              class="my-auto"
            >
              <timeframe-select
                v-model="filter"
                v-on:change="loadRecognitions"
                solo
                flat
                :outlined="false"
                small
              ></timeframe-select>
            </v-col>
            <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
              class="my-auto"
            >
              <v-text-field
                v-model="search"
                placeholder="Search for an employee"
                solo
                flat
                prepend-inner-icon="search"
                hide-details
                clearable
                class="subtitle-2 font-weight-regular"
              >
              </v-text-field>
            </v-col>
            <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
              class="my-auto"
            >
              <v-btn
                color="performance"
                @click="showCreateDialog"
                dark
                block
                large
                text
              >
                <v-icon class="mr-2">
                  add_circle
                </v-icon>
                <span class="secondarytext--text">Give Recognition</span>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </header-card>
      <v-row v-masonry>
        <v-col
          v-masonry-tile
          cols="12"
          sm="6"
          lg="4"
          v-for="item in filtered_recognitions"
          :key="item.id"
        >
          <recognition-card :recognition="item"> </recognition-card>
        </v-col>
      </v-row>
      <create-recognition-dialog
        ref="createRecognitionDialog"
        v-on:save="loadRecognitions"
      >
      </create-recognition-dialog>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CreateRecognitionDialog from "@/components/recognition/CreateRecognitionDialog";
import RecognitionCard from "@/components/recognition/RecognitionCard";
import HeaderCard from "@/components/common/HeaderCard";
import TimeframeSelect from "@/components/reporting/TimeframeSelect";
import moment from "moment";
export default {
  type: "RecognitionList",
  components: {
    CreateRecognitionDialog,
    RecognitionCard,
    HeaderCard,
    TimeframeSelect
  },
  data: () => ({
    loading: false,
    recognitionsLoading: false,
    filter: null,
    search: ""
  }),
  computed: {
    member_count() {
      return this._.uniq(this.recognitions.map(x => x.user.id)).length;
    },
    filtered_recognitions() {
      let recognitions = this.recognitions;
      if (this.search) {
        let search = this.search.toLowerCase();
        recognitions = recognitions.filter(
          x =>
            x.user.fullName.toLowerCase().indexOf(search) >= 0 ||
            (x.coreValueName || "").toLowerCase().indexOf(search) >= 0
        );
      }
      return this._.orderBy(recognitions, ["createdDate"], ["desc"]);
    },
    ...mapGetters({
      core_values: "company/coreValues",
      recognitions: "recognition/list"
    })
  },
  created() {
    this.filter = {
      timeframeId: this.$enums.timeframes.ALL_TIME,
      customStartDate: null,
      customEndDate: null,
      customTimezone: moment.tz.guess(true)
    };
    if (this.$route.query.q) {
      this.search = this.$route.query.q;
    }
    this.loading = true;
    this.$store
      .dispatch("company/getCoreValues")
      .then(() => {
        this.loadRecognitions({});
      })
      .catch(error => {
        this.logError(error);
        this.$root.$alert("Error Occurred", "An error occured while loading");
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    showCreateDialog() {
      this.$refs.createRecognitionDialog.showDialog();
    },
    loadRecognitions() {
      this.recognitionsLoading = true;
      this.$store
        .dispatch("recognition/getRecognitions", this.filter)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading recognitions."
          );
        })
        .finally(() => {
          this.recognitionsLoading = false;
        });
    }
  }
};
</script>
